import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseReportService } from '@app/api/api-services/base-report.service';
import { GoalsReportFiltersApiModel } from '@app/api/api-models/program/reports/mentoring/goals/GoalsReportFiltersApiModel';
import { GoalsReportRequestApiModel } from '@app/api/api-models/program/reports/mentoring/goals/GoalsReportRequestApiModel';
import { GoalsReportApiModel } from '@app/api/api-models/program/reports/mentoring/goals/GoalsReportApiModel';

@Injectable()
export class GoalsReportService extends BaseReportService<
  GoalsReportFiltersApiModel,
  GoalsReportRequestApiModel,
  GoalsReportApiModel
> {
  public readonly apiUrl = 'mt-reports/goals';

  public getReport(request: GoalsReportRequestApiModel): Observable<GoalsReportApiModel> {
    return super.getReport(request.serialize());
  }
}
